import { REVEAL } from './types';
import { triviaLoadActionThunk as load } from './load';
import { triviaFetchRankingPositionActionThunk as fetchRankingPosition } from './fetchRankingPosition';
import { triviaIdSelector } from '../selectors/id';
import { triviaAnswerSelector } from '../selectors/answer';
import { triviaLoadedDataSelector } from '../selectors/loadedData';

export const triviaRevealActionThunk = (triviaId) => async (dispatch, getState) => {
  await dispatch({ type: REVEAL });
  if (triviaId && triviaId !== triviaIdSelector(getState())) {
    await dispatch(load(triviaId, { notClearReveal: true }));
  }
  const state = getState();

  const loadedData = triviaLoadedDataSelector(state);
  const answer = triviaAnswerSelector(state);

  if (loadedData && answer) {
    await dispatch(fetchRankingPosition());
  }
};
